import { Fragment } from 'react'

import { Caption } from '@joor/design-system'
import styled from 'styled-components/macro'

import { numberWithCommas } from 'utils/formatters'

import { Quantity } from './Quantity'
import { Sizes } from './Sizes'
import messages from 'features/Orders/Review/components/Overview/components/ProductsWidget/constants/messages'
import { Casepack } from 'features/Orders/Review/components/Overview/components/ProductsWidget/types'

export function Casepacks({ casepacks, hasSkuPricing }: Props) {
  return (
    <Container>
      {casepacks.map(
        ({ name, sizes, totalSizedUnits, quantity, wholesalePrice }, index) => (
          <Fragment key={index}>
            <Caption
              type="2"
              typeface="montserrat"
              color={'primary-400'}
              className="notranslate"
            >
              {name}
            </Caption>
            <Row>
              <Quantity
                className="casepack-units"
                quantity={`${numberWithCommas(quantity)}x${numberWithCommas(
                  totalSizedUnits,
                )}`}
                label={messages.casepackQty}
                wholesalePrice={
                  hasSkuPricing ? numberWithCommas(wholesalePrice) : undefined
                }
              />
              <Sizes sizes={sizes} />
            </Row>
          </Fragment>
        ),
      )}
    </Container>
  )
}

type Props = {
  casepacks: Casepack[]
  hasSkuPricing: boolean
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  p {
    margin: 0 !important;
  }
`

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;

  .casepack-units {
    border-right: 1px solid var(--color-primary-100);
    padding-right: 4px;
  }
  & div:last-child {
    p {
      // changes in the DS component left this not working
      // had to use !important to override the color
      color: var(--color-primary-400) !important;
    }
  }
`
